import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import classnames from 'classnames';
import DatePicker from 'react-datepicker';

import Header from '../../../controls/header/Header.jsx';
import Image from '../../../controls/image/Image.jsx';
import CostTypeSelector from '../../../controls/costTypeSelector/CostTypeSelector.jsx';

import { routes } from 'pluton-core/lib/constants/routes.constant';
import { history } from '../../../../entry/history';

import {
    ICON_SETTING,
    IMAGE_LOGO
} from 'pluton-core/lib/constants/image.constant';
import { DATE_DETAILS_FORMAT } from 'pluton-core/lib/constants/data.constant';
import {
    controlItemsToRows,
    getControlItemStatus,
    getControlChartValueAndLabel
} from 'pluton-core/lib/services/core/control/control.helper';

import {
    VictoryLabel,
    VictoryAnimation,
    Style,
} from 'victory';
import { composeGaugeComponent } from 'pluton-charts/lib/charts/gauge/GaugeComponent';
const GaugeComponent = composeGaugeComponent({
    VictoryLabel,
    VictoryAnimation,
    Style,
    Svg: 'svg',
    Path: 'path',
    G: 'g',
    Line: 'line'
});


class ControlPage extends Component {

    handleChartType = (e) => {
        // this.props.handleChartType(e.target.value);
    };

    onGoToControlDetails = (control) => {
        history.push(routes.device(control.deviceId));
    };

    renderHeader = () => {
        return (
            <Header ref="headerRef" headerTitle='Controls'>
                <div className="header__logo header__logo--left">
                    <Image
                        src={IMAGE_LOGO}
                        className="header__icon"
                        imgClassName="icon icon--header"
                    />
                </div>
                <Link className="header__link header__link--right"
                      to={`${routes.settings()}`}>
                    <Image
                        src={ ICON_SETTING }
                        className="header__icon header__icon--right"
                        imgClassName="icon icon--header"
                    />
                </Link>
            </Header>
        );
    };

    renderBodyHeader = () => {
        return (
            <div ref="bodyHeaderRef" className="page__top">
                <div className="datepicker datepicker--control">
                    <DatePicker
                        ref="datepicker"
                        readOnly={true}
                        disabled={true}
                        autoFocus={false}
                        dateFormat={DATE_DETAILS_FORMAT}
                        selected={moment(this.props.controlsData.power.date)}
                        className='datepicker__field'
                    />
                </div>
                <Link className="link link--arrow link--control">
                    All
                </Link>
            </div>
        );
    };

    renderChart = () => {
        if (!this.props.controlsData.power) {
            return null;
        }

        const { value, label } = getControlChartValueAndLabel(this.props.controlsData.power.value);
        return (
            <div ref="chartRef" className="chart chart--appliance">
                <div className="chart__content">
                    <GaugeComponent
                        hideNeedle={this.props.controlsData.oldData.isOldData}
                        currentValue={this.props.controlsData.power.value / 1000}
                        maxValue={this.props.controlsData.powerLimits.maxOverload / 1000}
                        highValue={this.props.controlsData.powerLimits.maxPower / 1000}
                    />
                    <div className="chart__image">
                        <span className="chart__image-text">
                            {value}
                            <br/>
                            {label}
                        </span>
                    </div>
                </div>
                <div className="chart__legend">
                    <div className="legend-item legend-item--available">
                        <span className="legend-item__icon legend-item__icon--available"/>
                        <div className="legend-item__text">Available power</div>
                    </div>
                    <div className="legend-item legend-item--overload">
                        <span className="legend-item__icon legend-item__icon--overload"/>
                        <div className="legend-item__text">Overload</div>
                    </div>
                </div>
            </div>
        );
    };

    renderControl = (rowIndex, index, controlData) => {
        const { Icon } = controlData.data.icon;
        const statusText = getControlItemStatus(controlData);
        const classNames = classnames({
            'control__item': true,
            [controlData.status.className]: !!controlData.status.className,
        });

        return (
            <div className={classNames} key={(rowIndex+1)*index}
                 onClick={this.onGoToControlDetails.bind(null, controlData)}>
                <div className="control__item-img">
                    <Icon fill={controlData.status.color}/>
                </div>
                <div className="control__item-status">
                    {statusText}
                </div>
                <div className="control__item-name">
                    {controlData.data.name}
                </div>
            </div>
        );
    };

    renderControls = () => {
        if (!this.props.controlsData.items.length) {
            return null;
        }

        const itemsWithStatuses = this.props.controlsData.items.filter(i => !!i.status);
        if (!itemsWithStatuses.length) {
            return null;
        }

        let rows = controlItemsToRows(this.props.controlsData.items);
        const controlsView = rows.map((row, rowIndex) => {
            const rowView = row.map((columnItem, index) => {
                    return columnItem.status && this.renderControl(rowIndex, index, columnItem);
                }
            );

            return (
                <div className="control__section" key={rowIndex}>
                    {rowView}
                </div>
            );
        });

        const availableHeight = window.innerHeight
            - (this.refs.headerRef && this.refs.headerRef.refs.headerRef.clientHeight)
            - (this.refs.bodyHeaderRef && this.refs.bodyHeaderRef.clientHeight)
            - (this.refs.chartRef && this.refs.chartRef.clientWidth) * 3 / 4 - 25;
        // - window.innerWidth  - 10;

        return (
            <div className="control" style={{height:`${availableHeight}px`}}>
                {controlsView}
            </div>
        );
    };

    render() {
        return (
            <div className="app-container">
                <div className="page">
                    {this.renderHeader()}
                    <div className="page__content">
                        {this.renderBodyHeader()}
                        {this.renderChart()}
                        {this.renderControls()}
                    </div>
                </div>
            </div>
        );
    }
}

ControlPage.propTypes = {
    controls: React.PropTypes.object,
};

export default ControlPage;



// WEBPACK FOOTER //
// ./app/components/pages/core/control/Control.page.jsx